module.exports = __webpack_public_path__ + "img/004-visa.29242686.svg";